<div class="stacked-column container"
     #container>
    <svg:svg [attr.width]="dimensions.width"
             [attr.height]="dimensions.height">
        <defs>
            <filter id="shadow">
                <feDropShadow dx="0.5"
                              dy="0.5"
                              stdDeviation="3" />
            </filter>
        </defs>
        <svg:g id="chart"></svg:g>
        <svg:g aaTooltip
               [hovered]="hovered"
               [guideLines]="false"
               [dimensions]="dimensions"
               [tooltipData]="tooltipData"
               [formatTick]="tooltipFormatTick">
        </svg:g>
        <svg:g aaListeningZone
               [style.cursor]="'pointer'"
               [shiftClient]="true"
               (mousePosition)="onMousePosition($event)"
               (clickEvent)="onClickEvent($event)"
               (hovered)="onHovered($event)">
        </svg:g>
    </svg:svg>
</div>
